import { Component, OnDestroy, OnInit } from '@angular/core';
import { INRService } from '../../../../shared/services/inr.service';
import { Subject, takeUntil } from "rxjs";
import { APP_CONFIG } from '../../../../../environments/configurations/configurations';
import { TableColumn } from '../../../../shared/models/table-column';
import { INRPatientDTO } from '../../../../shared/models/inrPatientDTO';
import { LazyLoadEvent } from "primeng/api";

@Component({
  selector: 'app-inr-patients-list',
  templateUrl: './inr-patients-list.component.html',
  styleUrls: ['./inr-patients-list.component.css'],
})
export class InrPatientListComponent implements OnInit, OnDestroy {
  patients: INRPatientDTO[] = [];
  sourceData: INRPatientDTO[] = [];
  APP_CONFIG = APP_CONFIG;
  totalRecords: number = 0;
  destroy$: Subject<any> = new Subject<any>();
  showAssignPatientModal: boolean = false;
  lastLazyLoadEvent: LazyLoadEvent | null = null;

  constructor(private inrService: INRService) { }

  ngOnInit(): void {
    // Initial load will be triggered by p-table lazy load or can be called manually if needed
  }

  openAssignPatientModal() {
    this.showAssignPatientModal = true;
  }

  refreshList() {
    if (this.lastLazyLoadEvent) {
      this.loadPatients(this.lastLazyLoadEvent);
    }
  }

  loadPatients(event: LazyLoadEvent) {
    this.lastLazyLoadEvent = event;
    this.loading = true;
    this.inrService
      .getPatientList(event)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.loading = false;
          let inrPatientList = data.content || data; // Fallback if not paginated
          if (Array.isArray(inrPatientList)) {
            inrPatientList.map((item: any) => {
              if (item['mrn'])
                item['mrn'] = item['mrn'] ? item['mrn'].toString().replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : item['mrn'];
            });
            this.patients = inrPatientList;
            this.totalRecords = data.totalElements || inrPatientList.length;
          }
        },
        error: () => { this.loading = false; },
        complete: () => { this.loading = false; }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next('');
    this.destroy$.complete();
  }
  loading: boolean = false;
  columns: TableColumn[] = [
    { field: 'mrn', title: 'MRN', filter: { type: 'text' }, style: 'width: 12.5%; text-align: left !important' },
    { field: 'fullName', title: 'Patient', filter: { type: 'text' }, style: 'width: 12.5%; text-align: left !important' },
    { field: 'nationalId', title: 'National ID', filter: { type: 'text' }, style: 'width: 12.5%; text-align: left !important' },
    { field: 'lastTestDate', title: 'Last INR Test', filter: { type: 'date' }, style: 'width: 12.5%; text-align: left !important' },
    { field: 'lastInrValue', title: 'INR Value', filter: { type: 'text' }, style: 'width: 12.5%' },
    { field: 'initialMarivanDose', title: 'Marevan (mg)', style: 'width: 12.5%' },
    {
      field: 'isActive', title: 'Monitor Status',
      filter: { type: 'dropdown', options: [{ label: 'Active', value: 'true' }, { label: 'Inactive', value: 'false' }] }, style: 'width: 12.5%'
    },
    {
      field: 'isResponded', title: 'Response status',
      filter: { type: 'dropdown', options: [{ label: 'Responded', value: 'true' }, { label: 'Pending', value: 'false' }] }, style: 'width: 12.5%'
    },
  ];


}
